<template>
    <div v-if="Jdetail.detail" class="us-jrn-all-contaier">
        <!-- <pre>{{ Jdetail.images }}</pre> -->
        <div class="flexing">
            <div class="left col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="DetailReisePictureBlock">
                    <div class="HauptBild col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="Jdetail.images[0]">
                        <div
                            class="DetailLitPic zoomDetail"
                            id="Bigpic_0"
                            style="position:relative;cursor: pointer; background-position: center center; background-repeat: no-repeat; background-size: cover;"
                            v-bind:style="{ 'background-image': 'url(' + Jdetail.images[0].link + ')' }"
                        >
                            <a :title="Jdetail.images[0].description"  @click="showThePic(Jdetail.images[0].link, Jdetail.images[0].picture.copyright)"><div style="width:100%;height:199px;"></div></a>
                            <div style="position:absolute;bottom:5px;right:5px;color:#fff;text-shadow: 0px 0px 2px #000000;font-size:11px;">
                                {{ Jdetail.images[0].picture.copyright}}
                            </div>
                        </div>
                    </div>
                    <div class="NebenBild col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="Jdetail.images[1]">
                        <div
                            class="DetailLitPic zoomDetail"
                            id="Smallpics_1"
                            style="position:relative;cursor: pointer; background-position: center center; background-repeat: no-repeat; background-size: cover;"
                            v-bind:style="{ 'background-image': 'url(' + Jdetail.images[1].link + ')' }"
                        >
                            <a :title="Jdetail.images[1].description" @click="showThePic(Jdetail.images[1].link, Jdetail.images[1].picture.copyright)" ><div style="width:100%;height:138px;"></div></a>
                            <div style="position:absolute;bottom:5px;right:5px;color:#fff;text-shadow: 0px 0px 2px #000000;font-size:11px;">
                                {{ Jdetail.images[1].picture.copyright}}
                            </div>
                        </div>
                    </div>
                    <div class="NebenBild col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="Jdetail.images[2]">
                        <div
                            class="DetailLitPic zoomDetail"
                            id="Smallpics_2"
                            style="position:relative;cursor: pointer; background-position: center center; background-repeat: no-repeat; background-size: cover;"
                            v-bind:style="{ 'background-image': 'url(' + Jdetail.images[2].link + ')' }"
                        >
                            <a :title="Jdetail.images[2].description" @click="showThePic(Jdetail.images[2].link, Jdetail.images[2].picture.copyright)"><div style="width:100%;height:138px;"></div></a>
                            <div style="position:absolute;bottom:5px;right:5px;color:#fff;text-shadow: 0px 0px 2px #000000;font-size:11px;">
                                {{ Jdetail.images[2].picture.copyright}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="allleistungen" style="padding-left:0px;">
                    <div class="DetailReiseLeistungen">
                        <span>Unsere Leistungen</span>
                        <hr />
                        <ul v-html="Jdetail.detail.leistungen"></ul>
                    </div>
                </div>
            </div>
            <div class="right col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="TitelSub">
                    <div class="DetailReiseTitel">{{ Jdetail.detail.title }}</div>
                    <div class="DetailReiseSubtitel">{{ Jdetail.detail.subtitle }}</div>
                </div>
                <div class="DetailReiseAlleTage" v-for="(days, a) in Jdetail.days" :key="a">
                    <div class="LineSpace"></div>
                    <div class="DetailReiseEinzelTageHead">{{ days.title }}<br /></div>
                    <div class="DetailReiseEinzelTage">{{ days.text }}<br /></div>
                </div>
                <div class="bottom_box_right">
                    <div class="DetailReiseZusatzLeistungen" v-for="(date, b) in Jdetail.dates" :key="b">
                        <table width="95%">
                            <tbody>
                                <tr>
                                    <td class="zusatzleft" style="font-size:20px;font-weight:bold;white-space:nowrap;">
                                        {{ settheDate(date.dates.date_from) }} - {{ settheDate(date.dates.date_till) }}<br />
                                    </td>
                                    <td class="zusatzright">{{ date.dates.duration }} Tage</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><hr /></td>
                                </tr>
                                <tr v-if="date.dates.prices[1]">
                                    <td class="zusatzleft">EZ-Zuschlag</td>
                                    <td class="zusatzright">{{ date.dates.prices[1].price / 1000000 }} ,- €</td>
                                </tr>
                                <!-- <tr v-if="date.dates.prices[0].price == 0"> -->
                                <tr v-if="date.dates.prices.length == 0">
                                    <td class="zusatzleft">Preis nur auf Anfrage</td>
                                </tr>
                                <tr v-else>
                                    <td class="zusatzleft">Preis pro Person</td>
                                    <td class="zusatzright">{{ date.dates.prices[0].price / 1000000 }} ,- €</td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="display:flex;padding-top:20px; ">
                            <div class="hidden-phone hidden-tablet" style="vertical-align:top;padding-right:20px;" height="35px" width="20px">
                                <a href="javascript:window.print()"><img class="printimg" src="../assets/images/print1.png" height="100%"/></a>
                            </div>
                            <div class="DetailLitSuche" style="max-width:100%;vertical-align:middle;width:210px;height:35px;">
                                <a @click="setBookingData()"><img src="../assets/images/booking3.png" height="95%"/></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title="'Ansicht Bild' + tempPicname" :visible.sync="showPic" width="50%" append-to-body>
               <img :src="tempPicLink">
        </el-dialog>

        <el-dialog :title="'Buchungsanfrage ' + JourneyBuchung.journeyname" :visible.sync="showBuchung" width="50%" append-to-body>
            <Buchung :termine="Jdetail.dates" :reisename="Jdetail.detail.title" @getHiddenBooking="setHiddenBooking"></Buchung>
        </el-dialog>
    </div>
</template>

<script>
import Buchung from "./formulare/Buchung";
import moment from "moment";
import { mapState } from "vuex";

export default {
    computed: {
         ...mapState(["JourneyBuchung"]),

        journeyDescription() {
            let _desc = [];
            if (this.Jdetail.detail.einleitung && this.Jdetail.detail.einleitung !== "") {
                _desc.push(this.Jdetail.detail.einleitung);
            }
            if (this.Jdetail.detail.hotelbeschreibung && this.Jdetail.detail.hotelbeschreibung !== "") {
                _desc.push(this.Jdetail.detail.hotelbeschreibung);
            }

            return _desc.join("<br><br>");
        },
    },
    components: {
        Buchung,
    },
    mounted() {
        this.setJourneys();
    },
    data() {
        return {
            tempPicname:null,
            tempPicLink:null,
            showPic: false,

            showframe: false,
            framesrc: "",
            Jdetail: {},
            showBuchung: false,
            swiperOptionTop: {
                spaceBetween: 5,
                loop: true,
                loopedSlides: 4, //looped slides should be the same
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            swiperOptionThumbs: {
                spaceBetween: 5,
                slidesPerView: 4,
                touchRatio: 0.2,
                loop: true,
                loopedSlides: 4, //looped slides should be the same
                slideToClickedSlide: true,
            },
        };
    },
    watch: {
        $route(to, from) {
            this.setJourneys();
        },
    },
    methods: {
        showThePic(link, copyright){
            this.tempPicname = copyright
            this.tempPicLink = link
            this.showPic = true;

        },
        setHiddenBooking() {
            this.showBuchung=false;

        },
        setBookingData() {

            this.JourneyBuchung.journeyname = this.Jdetail.detail.title;


            this.showBuchung = true
        },
        settheDate(date) {
            return moment(String(date))
                .locale("de")
                .format("DD.MM.YYYY");
        },
        setJourneys() {
            let args = core.getPathArgs(["id"]);
            core.backend("jrn.getJourneyWeb", { id_jrn_journey: args.id }, (err, res) => {
                this.Jdetail = JSON.parse(JSON.stringify(res.data));

                if (this.Jdetail.detail.leistungen != "") {
                    this.Jdetail.detail.leistungen = "<li>" + JSON.parse(JSON.stringify(this.Jdetail.detail.leistungen.replace(/\n/g, "</li><li>")));
                }
                if (this.Jdetail.days.length === 1) {
                    if (this.Jdetail.days[0].title == "1. Tag" && this.Jdetail.days[0].text == "") {
                        this.Jdetail.days = [];
                    }
                }
            });
        },
        getJourneyDate(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from));
            }
            return (
                new Intl.DateTimeFormat("de-DE", { month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from)) +
                " - " +
                new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_till))
            );
        },
        getJourneyDuration(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return "1 Tag";
            }
            return Math.round((new Date(jrn.date_till) - new Date(jrn.date_from)) / 1000 / 60 / 60 / 24 + 1) + " Tage";
        },
        formatDate(date) {
            return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(date));
        },
        getReiseStatus(stat) {
            switch (stat) {
                case "A":
                    return { icon: "times-square", style: { color: "red" } };
                case "F":
                    return { icon: "check-square", style: { color: "green" } };
                default:
                    return { icon: "minus-square", style: { color: "orange" } };
            }
        },
    },
};
</script>

<style lang="scss" scoped>

@media (max-width: 979px) {

     .left{width:330px !important;}
     .right{width:330px !important;}
  }





#JourneySite,
#JourneySiteListe {
    position: relative;
    top: 5px;
    margin-bottom: 35px;
}

#JourneySite .zurueck a,
#JourneySiteListe .zurueck a {
    top: -10px;
}

#JourneySite .item-page,
#JourneySiteListe .item-page {
    /* margin-top:20px !important; */
}

.LitReiseStoererDetail {
    position: absolute;
    top: -15px;
    right: -15px;
}

.ReiseZurueckButton {
    width: 10px;
    height: 10px;
    position: relative;
    top: 13px;
    left: -15px;
    /* background: url("../images/mehr_zurueck.jpg"); */
}

.HeadLeft {
    float: left;
}

.DetailReiseTitel {
    font-weight: bold;
    text-transform: uppercase;
}
.DetailReiseSubtitel {
}
.DetailReiseTitelCon {
    background-color: #86063f;
}

.HeadRight {
    float: right;
    text-align: right;
}
.DetailReiseAbPreis {
    font-size: 24px !important;
    font-weight: bold;
    color: #cd1316;
    margin-right: 30px;
}
.DetailReiseTermine {
    margin-right: 30px;
    font-size: 18px;
    font-weight: bold;
}

.LineDetail {
    clear: both;
    height: 10px;
}
.DetailReisePictureBlock {
    display: table;
    width: 100%;
}

.HauptBild {
    float: left; /* margin-right:15px; */
    position: relative;
    width: 100%;
}
.HauptBild .DetailLitPic {
    display: tabel-cell;
    vertical-align: top;
    min-width: 100%;
    height: 199px;
}
@media screen and (min-width: 445px) {
    .NebenBild {
        width: 49.3% !important;
    }
}
.NebenBild {
    float: left;
    margin-right: 0px;
    margin-bottom: 0px;
    /* width:49.3%; */
}
.NebenBild .DetailLitPic {
    display: tabel-cell;
    vertical-align: top;
    height: 138px;
    margin-top: 5px;
}
.NebenBild:nth-child(2) {
    margin-right: 5px !important;
}

.TitelSub {
    background-color: #86063f;
    padding: 5px 10px;
    color: #fff;
    margin-bottom: 5px;
}

.DetailReiseAlleTage {
    /* width:516px;
float:left;*/
    margin-bottom: 10px;
}
.DetailReiseEinleitung {
    color: #272727;
    font-size: 12px;
    color: #676767;
}

.DetailReiseEinzelTageHead {
    /* font-weight:bold; */
    line-height: 20px;
    margin-bottom: 5px;
    font-weight: bold;
}

.allleistungen {
    margin-top: 5px;
    display: table;
    min-width: 100%;
    background: #86063f;
}

.DetailReiseLeistungen,
.DetailReiseZusatzLeistungen {
    width: 100%;
    position: relative;
    color: #fff;
    padding: 10px;
}
.TitelSub {
}
.DetailReiseLeistungen li:before,
.DetailReiseZusatzLeistungen li:before {
    color: #fff !important;
}
.DetailReiseLeistungen span,
.DetailReiseZusatzLeistungen span {
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    color: #fff;
}

.DetailLitSuche {
    clear: both;
    height: 25px;
    // background: #ff3019;
    // background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmMzAxOSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNjZjA0MDQiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
    // background: -moz-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    // background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #ff3019), color-stop(100%, #cf0404));
    // background: -webkit-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    // background: -o-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    // background: -ms-linear-gradient(top, #ff3019 0%, #cf0404 100%);
    // background: linear-gradient(to bottom, #ff3019 0%, #cf0404 100%);
    // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff3019', endColorstr='#cf0404',GradientType=0 );
    cursor: pointer;
    display: inline-block;
    width: 100px;
}
#buchan {
    background: none;
    border: 0;
    color: inherit;
    /* cursor: default; */
    font: inherit;
    line-height: normal;
    overflow: visible;
    padding: 0;
    -webkit-appearance: button; /* for input */
    -webkit-user-select: none; /* for button */
    -moz-user-select: none;
    -ms-user-select: none;
}

.Hammer_Empfehlen {
    height: 100px;
}
</style>
